module.exports = __webpack_public_path__ + "media/images/icons/icn_044-531cf80a69e18cf4b41d3c52bc794371.svg";